// Dumb FAB + filter dialog — no store, no SQL. Every decision lives in the app's
// filter composable (project-overview: useStatusTypeFilters; issue-analysis:
// useIssueStatusFilters), which the app shell owns; this file only renders the
// buttons and reports clicks.
//
//   props:  modelValue        (Boolean) v-model for the dialog
//           theme             (String)  'dark' | 'light' — drives the FAB colour
//                                       and which outline class marks "filtered"
//           itemTypes         (Array)   [{ key, label }] — the app's item types,
//                                       ALREADY TRANSLATED (see below)
//           statusTemplates   (Array)   visible statuses: { title, color, ... }
//           statusFilters     (Object)  keyed by status title -> Boolean
//           itemTypeFilters   (Object)  keyed by item type KEY -> Boolean
//           hasActiveFilter   (Boolean) draws the outline on the FAB
//           allFiltersSelected(Boolean) flips the Select All / Deselect All label
//           extraToggles      (Array)   OPT-IN [{ key, label, color? }] — extra boolean
//                                       filters, one checkbox each below the statuses,
//                                       ALREADY TRANSLATED (issue-analysis: "overdue only")
//           extraToggleValues (Object)  keyed by extra-toggle KEY -> Boolean
//   emits:  update:modelValue, toggleStatus(title), toggleType(key), toggleAll,
//           toggleExtra(key)
//
// Both sections are optional: no `itemTypes` hides the Item Types section (its heading,
// buttons and divider), no `extraToggles` renders no checkbox and no divider. With the
// defaults of the two opt-ins project-overview's dialog is unchanged (its item types are
// never empty); what the app does on a toggle — the SQL, the "active" outline — is app
// code, like the status and item-type filters.
//
// Chrome strings come from the colocated ./messages folder through a LOCAL composer
// (rule 11); see ./setup.js. The item-type LABELS deliberately do not: they are
// per-dashboard vocabulary ("issues"/"processes" here, something else on an asset
// dashboard), so the app translates them and passes `[{ key, label }]`. `key` is what
// the filter engine indexes and what `toggleType` emits; `label` is only ever rendered.
import setup from './setup.js';

export default {
  name: 'status-filter-fab',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'light'
    },
    itemTypes: {
      type: Array,
      default: () => [],
      validator: (value) => value.every(
        (type) => type && typeof type.key === 'string' && typeof type.label === 'string'
      )
    },
    statusTemplates: {
      type: Array,
      default: () => []
    },
    statusFilters: {
      type: Object,
      default: () => ({})
    },
    itemTypeFilters: {
      type: Object,
      default: () => ({})
    },
    hasActiveFilter: {
      type: Boolean,
      default: false
    },
    allFiltersSelected: {
      type: Boolean,
      default: false
    },
    extraToggles: {
      type: Array,
      default: () => [],
      validator: (value) => value.every(
        (toggle) => toggle && typeof toggle.key === 'string' && typeof toggle.label === 'string'
      )
    },
    extraToggleValues: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue', 'toggleStatus', 'toggleType', 'toggleAll', 'toggleExtra'],
  setup,
};
